import { memo } from "react";

import { WorkerPool } from "types/generated";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";

import WorkerPoolDeleteAction from "../WorkerPool/DeleteAction";
import WorkerPoolResetAction from "../WorkerPool/ResetAction";
import WorkerPoolCycleAction from "../WorkerPool/CycleAction";
import WorkerPoolUpdateAction from "../WorkerPool/UpdateAction";
import { showCycleConfirmation } from "../WorkerPool/CycleConfirmation";
import { showResetConfirmation } from "../WorkerPool/ResetConfirmation";
import { showDeleteConfirmation } from "../WorkerPool/DeleteConfirmation";

export type WorkerPoolsListItemDropdownProps = {
  onEdit: () => void;
  workerPool: WorkerPool;
};

const WorkerPoolsListItemDropdown = ({ onEdit, workerPool }: WorkerPoolsListItemDropdownProps) => {
  const handleOnCycle = () => {
    showCycleConfirmation({ id: workerPool.id, name: workerPool.name });
  };

  const handleOnReset = () => {
    showResetConfirmation({ id: workerPool.id, name: workerPool.name });
  };

  const handleOnDelete = () => {
    showDeleteConfirmation({ id: workerPool.id, name: workerPool.name });
  };

  return (
    <DropdownMenuEllipsis tooltip="Worker pool actions" dotsSize="small">
      <CopyFieldDropdownMenuItem title="Copy ID" value={workerPool.id} />
      <WorkerPoolUpdateAction onAction={onEdit} workerPool={workerPool} />
      <WorkerPoolCycleAction onAction={handleOnCycle} workerPool={workerPool} />
      <WorkerPoolResetAction onAction={handleOnReset} workerPool={workerPool} />
      <WorkerPoolDeleteAction onAction={handleOnDelete} workerPool={workerPool} />
    </DropdownMenuEllipsis>
  );
};

export default memo(WorkerPoolsListItemDropdown);
